<template>
             <a :href="_.get(row_data, 'file[0].url')" class="download__row flex j_sb br-6 pointer a_center">
                    <h3 class="bold">{{ row_data.file_title }}{{ row_data.file_extensions}}</h3>
                      <svg id="Group_7" data-name="Group 7" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <circle id="Oval" cx="12" cy="12" r="12" fill="#7063e9"/>
                        <path id="Combined_Shape" data-name="Combined Shape" d="M5.293,11.707a1,1,0,0,1,0-1.414L8.586,7H1A1,1,0,0,1,1,5H8.586L5.293,1.707A1,1,0,0,1,6.707.292l5,5a1,1,0,0,1,.065,1.342l-.005.006-.01.011-.012.014,0,0-.04.042-5,5a1,1,0,0,1-1.414,0Z" transform="translate(18 6) rotate(90)" fill="#fff"/>
                        </svg>
                    </a>
</template>

<script>
export default {
    props: ['row_data'],

}
</script>

<style>

</style>